var exports = {
  "x6": "DownloadButton.module__button___QkJhSk",
  "td": "DownloadButton.module__iconText___QkJhSk",
  "ro": "DownloadButton.module__menuIcon___QkJhSk",
};

module.exports = exports;
